import React from "react";

export default function Loader() {
  return (
    <div className="typing-loader">
      <span></span>
      <span></span>
      <span></span>
      <style>{`
        .typing-loader {
          display: flex;
          gap: 4px;
          padding: 5px 0;
        }
        .typing-loader span {
          width: 6px;
          height: 6px;
          background: #00ced1;
          border-radius: 50%;
          display: block;
          animation: bounce 1.4s infinite ease-in-out both;
        }
        .typing-loader span:nth-child(1) { animation-delay: -0.32s; }
        .typing-loader span:nth-child(2) { animation-delay: -0.16s; }
        @keyframes bounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1.0); }
        }
      `}</style>
    </div>
  );
}